import { trigger, state, style, transition, animate } from '@angular/animations';
import { Component, ElementRef, HostListener, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { CommonDataService } from 'src/app/common/services/common-data.service';
import { ConfigurationService } from 'src/app/common/services/configuration.service';
import { LoginService } from 'src/app/common/services/Login.service';
import { GraphqlService } from '../../common/services/graphql.service';
import scrollIntoView from 'scroll-into-view-if-needed';
import { UtilityService } from '../../common/services/utility-service';

@Component({
  selector: 'app-right-overlay',
  templateUrl: './right-overlay.component.html',
  styleUrls: ['./right-overlay.component.css'],
  animations:[
    trigger('slideInOut',[
      state('in', style({
        transform : 'translate3d(0,0,0)',
        opacity : 1,
      })),
      state('out', style({
        transform : 'translate3d(10%,0,0)',
        opacity : 0,
      })),
      transition('in => out', animate('400ms ease-in-out')),
      transition('out => in', animate('400ms ease-in-out')),
    ])
  ]
})
export class RightOverlayComponent implements OnInit {
  
  @HostListener('document:keydown',['$event']) onKeyPress(event : KeyboardEvent){
    if (event.key === "Escape" && this.isPopUpOpen == false) {
      if (this.overlayOption != 'Terms And Conditions' && this.overlayOption != 'About GARS') {
        this.overlayState = "out";
        setTimeout(() => {
          this.showOverlay = false;
        }, 400)
      }
    }
  }

  @HostListener('document:mousewheel', ['$event']) 
  onDocumentMousewheelEvent(event) {
    var div = document.getElementById('printscroll');
    if (div != null) {
      var vs = div.scrollHeight > div.clientHeight;
      if (vs) {
        document.getElementById("topLoad").style.display = "";
      }
      else {
        document.getElementById("topLoad").style.display = "none";
      }
    }      
  }


  constructor(
    private elementref:ElementRef,
    public commonDataService : CommonDataService,
    public configurationServce : ConfigurationService,
    public _loginservice: LoginService,
    public domSanitizer: DomSanitizer,
    private route: Router,
    private graphQLService: GraphqlService,
    private utilityService: UtilityService
  ) { }

  printBreadcrumb: boolean = true;
  showOverlay : boolean = false;
  overlayState : string = "out";
  contentWidth : string = "50%";
  currentParagraph : string;
  overlayOption: string;
  previewFileName: string = "";
  navData = {
    crumbData : [],
  };
  isShowAllInOnePage: boolean = false;
  closeModalBool: boolean;
  closeModalAction: boolean;
  logo
  isPopUpOpen: boolean;
  dateNow: string;
  year: string;
  glossaryTermData:any=[];
  contentPaddingValue: string;
  mainsectionname: string = "";
  sectionname: string = "";
  childComponent:boolean=false;
  archiveVersion: string = "";
  ngOnInit(): void {
    this.previewFileName = "";
    this.dateNow = new Date().toLocaleDateString('en-us', { year: "numeric", month: "numeric", day: "numeric", hour: "numeric", minute: "numeric" });
    this.year = new Date().getFullYear().toString();
    this.getArchiveVersionHeaderValue();
    this.commonDataService.showRightPanel.subscribe(data => {
      this.getArchiveVersionHeaderValue();
      this.dateNow = new Date().toLocaleDateString('en-us', { year: "numeric", month: "numeric", day: "numeric", hour: "numeric", minute: "numeric" });
      if (data) {
        this.showOverlay = true;
        setTimeout(() => {
          this.overlayState = "in";
        }, 40)
        if (this.route.url.includes('showallinonepage')) {
          this.isShowAllInOnePage = true;
        }
        else {
          this.isShowAllInOnePage = false;
        }
        if (this.route.url == "/about-us" || this.route.url.includes("/tableOfContent") || this.route.url == "/copy-right" || this.route.url == "/terms-and-conditions" || this.route.url.includes("/help") || this.route.url.includes("/pdfHelp")) {
          this.printBreadcrumb = false;
          this.contentPaddingValue = "padding-right-general-page"
        }
        else {
          this.printBreadcrumb = true;
          this.contentPaddingValue = "padding-right-content-page"
        }
      }
    });
    this.commonDataService.rightPanelWidth.subscribe(data => {
      this.dateNow = new Date().toLocaleDateString('en-us', { year: "numeric", month: "numeric", day: "numeric", hour: "numeric", minute: "numeric" });
      let str  = data;
      this.contentWidth = this.configurationServce[str];
    })

    this.commonDataService.rightOverlayOption.subscribe(data => {
      this.dateNow = new Date().toLocaleDateString('en-us', { year: "numeric", month: "numeric", day: "numeric", hour: "numeric", minute: "numeric" });
      this.overlayOption = data;
    })

    this.commonDataService.isConfirmationPopUpOpen.subscribe(data => {
      this.dateNow = new Date().toLocaleDateString('en-us', { year: "numeric", month: "numeric", day: "numeric", hour: "numeric", minute: "numeric" });
          this.isPopUpOpen = data;
    })
    this.commonDataService.glossaryTermData.subscribe(termData => {
      this.dateNow = new Date().toLocaleDateString('en-us', { year: "numeric", month: "numeric", day: "numeric", hour: "numeric", minute: "numeric" });
      this.glossaryTermData=termData;
    })
    // this.commonDataService.currentParagraph.subscribe(data => {
    //   this.currentParagraph = data;
    // })

    // this.navData = JSON.parse(JSON.stringify(this.commonDataService.navData.getValue()));

    // this.checkHome();
    this.commonDataService.closeModalOption.subscribe(data => {
      this.closeModalBool = data;
    })
    this.commonDataService.closeandActionOption.subscribe(data => {
      this.closeModalAction = data;
    })
    this.loadLogo()

    this.commonDataService.printpreviewFileName.subscribe(data => {
      this.dateNow = new Date().toLocaleDateString('en-us', { year: "numeric", month: "numeric", day: "numeric", hour: "numeric", minute: "numeric" });
      this.previewFileName = data;
    })

    // this.childComponent = this.commonDataService.parentComponentDetails.getValue().length > 0 ? true : false;
    this.commonDataService.parentComponentDetails.subscribe(data => {
      this.dateNow = new Date().toLocaleDateString('en-us', { year: "numeric", month: "numeric", day: "numeric", hour: "numeric", minute: "numeric" });
      this.childComponent = data.length > 0 ? true : false;
    })
  }

  getArchiveVersionHeaderValue() {
    if (localStorage.getItem("ArchiveVersion") != null && localStorage.getItem("ArchiveVersion") != undefined) {
      this.archiveVersion = this.utilityService.convertMonthYear(localStorage.getItem("ArchiveVersion"));
    }
    else {
      if (localStorage.getItem("CurrentVersion") != null && localStorage.getItem("CurrentVersion") != undefined) {
        this.archiveVersion = this.utilityService.convertMonthYear(localStorage.getItem("CurrentVersion"));
      }
      else {
        this.graphQLService.getCurrentVersionName().subscribe(currentVersionData => {
          this.archiveVersion = currentVersionData;
          localStorage.setItem("CurrentVersion", currentVersionData);
        });
      }
    }
  }

  checkHome(){
    if(this.navData.crumbData.length === 0){
      this.navData.crumbData.push("Home")
    }
  }

  startAnimation(){
  }

  animationDone(){
  }

  overlayClicked(){

  }

  overlayContentClicked(){
  }

  closeOverlay(){
    this.overlayState = "out";
    this.commonDataService.parentComponentDetails.next([]);
      setTimeout(()=>{
        this.showOverlay = false;
        this.commonDataService.annotationContent.next(null);
      },400) 
  }
  closeOverlayPrintPreview() {
    this.commonDataService.displayallannotation.next("hidePrintallannotations");
    var hide = document.getElementsByClassName("print-content-hide")
    Array.prototype.forEach.call(hide, function (obj) {
      obj.style.display = "flex"
    });
    var printOnly = document.getElementsByClassName("print");
    Array.prototype.forEach.call(printOnly, function (obj) {
      obj.style.display = "none"
    });
    this.overlayState = "out";
    setTimeout(() => {
      this.showOverlay = false;
      this.commonDataService.annotationContent.next(null);
    }, 1000)   
  }

  closeOverlayAnnotation() {
    this.overlayState = "out";
    setTimeout(() => {
      this.showOverlay = false;
      this.commonDataService.annotationContent.next(null);
    }, 400)
  }
  closeOverlayBookmark() {
  this.overlayState = "out";
  setTimeout(() => {
    this.showOverlay = false;
    //this.commonDataService.bookmarkId.next(null);
  }, 400)
  }

  closeRightOverlay() {
    this.overlayState = "out";
    setTimeout(() => {
      this.showOverlay = false;
    }, 400);
  }

  loadLogo() {
    this.graphQLService.getS3BucketImageGARSLogo().subscribe(data => {
      this.logo = this.domSanitizer.bypassSecurityTrustUrl(data);
    });
  }


  gotoSection() {  
    // document.getElementById('scrollToTop').scrollIntoView();  
    scrollIntoView(document.getElementById('scrollToTop'), {
      scrollMode: 'always',
      block: 'start',
      inline: 'start',
      behavior: 'smooth',
      boundary: document.getElementsByTagName('app-main-content')[0]
    })
  }
  glossaryTermId: string = "";
  viewPreviousScreen(){
    let componentDetails=this.commonDataService.parentComponentDetails.getValue();
    if(componentDetails?.length!=0){
      let currentComponent=componentDetails.pop();
      this.commonDataService.rightPanelWidth.next(currentComponent.panelWidth);
      this.commonDataService.rightOverlayOption.next(currentComponent.source);
      if(currentComponent.source=="glossary-term-usage"){
        this.commonDataService.glossaryTermData.next(currentComponent.data);
      }
      else if(currentComponent.source=="inline-glossary"){
        this.commonDataService.glossaryTermId.next(currentComponent.data);
        this.glossaryTermId=currentComponent.data;
      }
      else if(currentComponent.source=="What Links Here"){
        this.commonDataService.navDataContentPage.next(currentComponent.data);
      }
      this.childComponent = this.commonDataService.parentComponentDetails.getValue().length > 0 ? true : false;
    }
  }
}
